var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{staticClass:"form-particle-trail",attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }